module.exports = __webpack_public_path__ + "static/media/poicon23.3922e144.svg";